var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "process-content", staticStyle: { overflow: "hidden" } },
    [
      _c(
        "el-upload",
        {
          ref: "uploader",
          staticClass: "drop-uploader",
          staticStyle: { height: "32px" },
          attrs: {
            drag: "",
            action: "",
            limit: 1,
            headers: _vm.headers,
            "file-list": _vm.fileList,
            "auto-upload": false,
            "show-file-list": false,
            "on-change": _vm.toChooseFile
          }
        },
        [
          _c("div", { staticClass: "drop-uploader-icon" }, [
            _c("p", { staticStyle: { display: "inline-block" } }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.UploadFile")))
            ])
          ])
        ]
      ),
      _vm.fileList && _vm.fileList.length > 0
        ? _c(
            "div",
            { staticStyle: { "margin-top": "10px", cursor: "pointer" } },
            _vm._l(_vm.fileList, function(file, index) {
              return _c("div", { key: index, staticClass: "file-style" }, [
                _c("div", { staticStyle: { margin: "7px", display: "flex" } }, [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(file.fileName))
                  ]),
                  _c("span", { staticStyle: { color: "darkgray" } }, [
                    _vm._v(
                      _vm._s(_vm.WorkflowUtil.fileSizeLabel(file.fileSize))
                    )
                  ]),
                  _c("i", {
                    staticClass: "el-icon-close",
                    staticStyle: { float: "right" },
                    on: {
                      click: function($event) {
                        return _vm.remove(file.fileId)
                      }
                    }
                  })
                ])
              ])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }